import React, { useState, useEffect } from 'react';
import { useFormik } from 'formik';
import yup from '../../../common/utils/yup';
import { TextField, AutoComplete, Select } from 'porosys-ui';
import { getDepartments } from '../../../common/services/api/CommonApis/Department';
import { createUser, updateUser } from '../api';
import Form from '../../../common/ui/components/MainForm/MainForm';
import '../styles.scss';

const validationSchema = yup.object({
    fullname: yup.string().required(),
    departments: yup.array().required().min(1, 'حداقل یک واحد باید انتخاب شده باشد').nullable(true),
    password: yup.string(),
    role: yup.string().required(),
    email: yup.string().required(),
    anotherEmail: yup.string(),
});

const UserForm = props => {
    const { handleCancel, handleAddUser, handleUpdateUser, userToEdit } = props;
    const [shouldEditData, setShouldEditData] = useState(false);
    const [departments, setDepartments] = useState([]);
    const inputValues = userToEdit
        ? {
              _id: userToEdit._id,
              fullname: userToEdit.fullname,
              password: '',
              departments: userToEdit.departments,
              role: userToEdit.role,
              email: userToEdit.email || '',
              anotherEmail: userToEdit.anotherEmail || '',
          }
        : {
              fullname: '',
              password: '',
              departments: [],
              role: '',
              email: '',
              anotherEmail: '',
          };

    useEffect(() => {
        userToEdit ? setShouldEditData(true) : setShouldEditData(false);
        const fetchDepartments = async () => {
            setDepartments(await getDepartments());
        };
        fetchDepartments();
    }, []);

    const { handleSubmit, values, handleChange, touched, errors, setFieldValue } = useFormik({
        initialValues: inputValues,
        onSubmit: values => {
            const data = { ...values };
            const newDepartments = values.departments.filter(department => department._id != null);
            data.departments = newDepartments.map(department => department._id);
            data.departments = [...new Set(data.departments)];

            if (!data.anotherEmail) data.anotherEmail = data.email;

            !shouldEditData
                ? createUser(data).then(res => {
                      handleAddUser(res);
                  })
                : delete data.email &&
                  updateUser(data).then(res => {
                      handleUpdateUser(res);
                  });
        },
        validationSchema,
    });

    const handleError = state => {
        if (touched[state] && errors[state]) return errors[state];
    };

    return (
        <div>
            <Form
                formTitle={userToEdit ? `ویرایش کاربر ${userToEdit.fullname}` : `افزودن کاربر جدید`}
                handleCancel={handleCancel}
                handleSubmit={handleSubmit}
            >
                <TextField
                    classes={{ root: 'form-input' }}
                    value={values.fullname}
                    label={'نام'}
                    name="fullname"
                    placeholder="وارد کنید..."
                    onChange={handleChange('fullname')}
                    errorMessage={handleError('fullname')}
                />{' '}
                <TextField
                    classes={{ root: 'form-input' }}
                    value={values.email}
                    label={'ایمیل'}
                    name="email"
                    placeholder="وارد کنید..."
                    onChange={handleChange('email')}
                    errorMessage={handleError('email')}
                />
                <TextField
                    classes={{ root: 'form-input' }}
                    value={values.anotherEmail}
                    label={'ایمیل دوم'}
                    name="anotherEmail"
                    placeholder="وارد کنید..."
                    onChange={handleChange('anotherEmail')}
                    errorMessage={handleError('anotherEmail')}
                />
                <TextField
                    classes={{ root: 'form-input' }}
                    value={values.password}
                    label={'رمز عبور'}
                    name="password"
                    placeholder="وارد کنید..."
                    onChange={handleChange('password')}
                    errorMessage={handleError('password')}
                    type="password"
                />
                <AutoComplete
                    selected={values.departments}
                    classes={{ input: 'form-input' }}
                    label="واحد های مربوطه"
                    multiple
                    onChange={(e, newValue) => {
                        setFieldValue('departments', newValue);
                    }}
                    getOptionSelected={(option, value) => option._id === value._id}
                    getOptionLabel={option => {
                        return (option && 'label' in option && option.label) || '';
                    }}
                    options={departments}
                    placeholder="انتخاب کنید..."
                    errorMessage={handleError('departments')}
                />
                <Select
                    selected={values.role}
                    classes={{ root: 'form-input ' }}
                    label="دسترسی"
                    onChange={handleChange('role')}
                    options={[
                        {
                            label: 'ادمین',
                            value: 'admin',
                        },
                        {
                            label: 'اپراتور',
                            value: 'operator',
                        },
                        {
                            label: 'کاربر',
                            value: 'user',
                        },
                    ]}
                    placeholder="انتخاب مکان"
                    errorMessage={handleError('role')}
                />
            </Form>
        </div>
    );
};

export default UserForm;
